
(function () {
  function initScrollingLogo(section) {
    const wrapper = section.querySelector('.scrolling-logo__wrapper');
    const rail = section.querySelector('.scrolling-logo__rail');

    if (!wrapper || !rail) return;

    if (rail._marqueeAnimation) {
      cancelAnimationFrame(rail._marqueeAnimation);
      rail._marqueeAnimation = null;
    }

    rail.querySelectorAll('[data-marquee-clone]').forEach(function (clone) {
      clone.remove();
    });

    rail.style.transform = 'translate3d(0, 0, 0)';

    const originalItems = Array.from(
      rail.querySelectorAll('.scrolling-logo__item')
    );

    if (!originalItems.length) return;

    const direction =
      section.dataset.scrollDirection === 'right' ? 1 : -1;

    const gap = parseFloat(
      window.getComputedStyle(rail).columnGap ||
      window.getComputedStyle(rail).gap ||
      0
    );

    function getSequenceWidth(items) {
      let width = 0;

      items.forEach(function (item) {
        width += item.getBoundingClientRect().width;
      });

      if (items.length > 1) {
        width += gap * (items.length - 1);
      }

      return width;
    }

    let sequenceWidth = getSequenceWidth(originalItems);

    if (!sequenceWidth) return;

    const wrapperWidth = wrapper.getBoundingClientRect().width;

    while (sequenceWidth < wrapperWidth) {
      const currentItems = Array.from(
        rail.querySelectorAll('.scrolling-logo__item:not([data-marquee-clone])')
      );

      currentItems.forEach(function (item) {
        const clone = item.cloneNode(true);

        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-marquee-clone', 'true');

        rail.appendChild(clone);
      });

      const newOriginalItems = Array.from(
        rail.querySelectorAll('.scrolling-logo__item:not([data-marquee-clone])')
      );

      const allItems = Array.from(
        rail.querySelectorAll('.scrolling-logo__item')
      );

      sequenceWidth = getSequenceWidth(newOriginalItems);

      if (getSequenceWidth(allItems) < wrapperWidth * 2) {
        const cloneSet = newOriginalItems.map(function (item) {
          const clone = item.cloneNode(true);

          clone.removeAttribute('data-shopify-editor-block');
          clone.setAttribute('data-marquee-clone', 'true');

          return clone;
        });

        cloneSet.forEach(function (clone) {
          rail.appendChild(clone);
        });
      }

      break;
    }

    const firstSet = Array.from(
      rail.querySelectorAll('.scrolling-logo__item:not([data-marquee-clone])')
    );

    firstSet.forEach(function (item) {
      const clone = item.cloneNode(true);

      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('data-marquee-clone', 'true');

      rail.appendChild(clone);
    });

    sequenceWidth = getSequenceWidth(firstSet);

    const speed = 80;
    let position = direction === -1 ? 0 : -sequenceWidth;
    let previousTime = null;

    if (direction === 1) {
      rail.style.transform =
        'translate3d(' + (-sequenceWidth) + 'px, 0, 0)';
    }

    function animate(time) {
      if (!previousTime) {
        previousTime = time;
      }

      const delta = (time - previousTime) / 1000;
      previousTime = time;

      position += direction * speed * delta;

      if (direction === -1) {
        if (position <= -sequenceWidth) {
          position += sequenceWidth;
        }
      } else {
        if (position >= 0) {
          position -= sequenceWidth;
        }
      }

      rail.style.transform =
        'translate3d(' + position + 'px, 0, 0)';

      rail._marqueeAnimation = requestAnimationFrame(animate);
    }

    rail._marqueeAnimation = requestAnimationFrame(animate);
  }

  function initAll() {
    document
      .querySelectorAll('[data-scrolling-logo]')
      .forEach(function (section) {
        initScrollingLogo(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector
      ? event.target.querySelector('[data-scrolling-logo]')
      : null;

    if (section) {
      initScrollingLogo(section);
    }
  });

  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      initAll();
    }, 250);
  });
})();

